const INVENTORY_SOURCE_ROUTE_PREFIX = "/dropshipping/inventory-source";
const INVENTORY_SOURCE_PAGES = Object.freeze([
  "DropshippingInventorySourceDashboard", "DropshippingInventorySourceConnect",
  "DropshippingInventorySourceSuppliers", "DropshippingInventorySourceSupplierProducts",
  "DropshippingInventorySourceAllProducts", "DropshippingInventorySourceProductDetails",
  "DropshippingInventorySourceImportedProducts", "DropshippingInventorySourceOrders",
  "AdminDropshippingInventorySource", "AdminInventorySourceConnections",
  "AdminInventorySourceSuppliers", "AdminInventorySourceProducts", "AdminInventorySourceLogs",
  "AdminInventorySourceOrders",
]);
module.exports = { INVENTORY_SOURCE_ROUTE_PREFIX, INVENTORY_SOURCE_PAGES };
